import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { OfferSection } from '../components/OfferSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { MetaPixel } from '../components/MetaPixel';
export function LandingPage() {
  return <>
      <MetaPixel data-id="element-224" />
      <div className="w-full min-h-screen bg-bg-primary" data-id="element-225">
        <Hero data-id="element-226" />
        <ProblemSection data-id="element-227" />
        <SolutionSection data-id="element-228" />
        <BenefitsSection data-id="element-229" />
        <TestimonialSection data-id="element-230" />
        <OfferSection data-id="element-231" />
        <FAQSection data-id="element-232" />
        <FinalCTA data-id="element-233" />
      </div>
    </>;
}